/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore, Store } from "vuex";
import { menus } from "./modules/menus";
import { permissions } from "./modules/permissions";
import { masterData } from "./modules/master.data";
import { medias } from "./modules/media";
import { currentPath } from "./modules/currentPath";

// Define the root state interface
export interface RootState {
  processLoad: boolean;
  pageTitle: string;
  profile: Record<string, any>;
  apiUrl: object;
  listSubSidebar: object[];
  isSearchMap: object;
  appMode: string;
}

// Create the Vuex store
const store = createStore<RootState>({
  // Modules
  modules: {
    menus,
    permissions,
    masterData,
    medias,
    currentPath,
  },
  // Initial state
  state: {
    processLoad: true,
    pageTitle: document.title,
    profile: {},
    apiUrl: {},
    listSubSidebar: [],
    isSearchMap: {
      modal: false,
      value: "",
    },
    appMode: localStorage.getItem("applicationMode") || "light-mode",
  },
  // Mutations to modify state
  mutations: {
    storeProcessLoad(state, item) {
      state.processLoad = item;
    },
    storePageTitle(state, item) {
      state.pageTitle = item;
    },
    storeProfile(state, item) {
      state.profile = item;
    },
    storeApiUrl(state, item) {
      state.apiUrl = item;
    },
    storeListSubSidebar(state, item) {
      state.listSubSidebar = item;
    },
    storeIsSearchMap: (state, item) => {
      state.isSearchMap = item;
    },
    storeAppMode: (state, item) => {
      state.appMode = item;
    },
  },
  // Actions to perform async operations/mutations
  actions: {
    updateProcessLoad({ commit }, item) {
      commit("storeProcessLoad", item);
    },
    updatePageTitle({ commit }, item) {
      commit("storePageTitle", item);
    },
    updateProfile({ commit }, item) {
      commit("storeProfile", item);
    },
    updateApiUrl({ commit }, item) {
      commit("storeApiUrl", item);
    },
    updateListSubSidebar({ commit }, item) {
      commit("storeListSubSidebar", item);
    },
    updateIsSearchMap({ commit }, item) {
      commit("storeIsSearchMap", item);
    },
  },
  // Getters to access computed state properties
  getters: {},
});

// Export the store instance with correct type
export default store as Store<RootState>;
